import * as types from './mutation-types'

const mutations = {
  // 设置用户信息
  [types.SET_USERINFO] (state, userObj) {
    state.userInfo = userObj
  },

  // 设置是否登陆
  [types.SET_LOGIN] (state, isLogin) {
    state.isLogin = isLogin
  },

  // 设置租户信息
  [types.SET_COMPANYINFO] (state, companyInfo) {
    state.companyInfo = companyInfo
  },

  // 设置token过期时间
  [types.SET_TOKENTIMEOUT] (state, tokenTimeout) {
    state.tokenTimeout = tokenTimeout
  },

  // 设置租户Id
  [types.SET_TENANTID] (state, tenantId) {
    state.tenantId = tenantId
  },

  // 设置购物车数量
  [types.SET_CHATNUM] (state, chatNum) {
    state.chatNum = chatNum
  },

  // 设置分类搜索
  [types.SET_CLASSIFICATION] (state, classification) {
    state.classification = classification
  },
  // 设置图片来源拼接地址
  [types.SET_OSSFILEURL] (state, ossFileUrl) {
    state.ossFileUrl = ossFileUrl
  },

  //
  [types.SET_USERCOLUMNSSETTING] (state, userColumnsSetting) {
    // 列设置
    state.userColumnsSetting.listSetting = userColumnsSetting?.listSetting || []
    // 搜索设置
    state.userColumnsSetting.searchSetting = userColumnsSetting?.searchSetting || []
    // 搜索是否隐藏搜条件设置
    state.userColumnsSetting.isSearchHidden = userColumnsSetting.isSearchHidden || 0
  }
}
export default mutations
